// import $ from "jquery";
const intersections = {
    intersectionHTML: document.querySelector('#js-intersections'),
    intersectionList: [],
    parseHTML() {
        for (const intersection of this.intersectionHTML.children) {
            const data = intersection.dataset;
            let html = '';
            let styles = [];
            for (let child of intersection.children) {
                switch (child.tagName.toLowerCase()) {
                    case 'custom-html':
                        for (let subChild of child.children) {
                            if (subChild.tagName.toLowerCase() === 'style') {
                                styles.push(subChild.textContent);
                                subChild.remove();
                            }
                        }
                        html = child.innerHTML;
                        break;

                    case 'custom-style':
                        styles.push(child.textContent);
                        break;

                    default:
                        console.info('Unhandled tag:', child.tagName);
                        break;
                }
            }

            this.intersectionList.push({
                type: data.type,
                id: data.id,
                pos: parseInt(data.pos, 10),
                width: data.width,
                html: html,
                styles: styles
            });

            intersection.innerHTML = '';
        }
    }
};

$(() => {
    if (intersections.intersectionHTML) {
        intersections.parseHTML();
    }
});

export default intersections;
